import React from "react";
import verify from "../../assets/verify.jpg";
import header from "../../assets/customercare.png";

const Support = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between max-w-7xl mx-auto p-6 gap-10">
      {/* Image Section */}
      <div className="md:w-1/2 flex justify-center">
        <img
          src={header}
          alt="Customer Care"
          className="w-full max-w-md md:max-w-lg "
        />
      </div>

      {/* Content Section */}
      <div className="md:w-1/2 md:text-left">
        <div className="flex items-center justify-center md:justify-start gap-2">
          <h1 className="text-2xl text-left md:text-4xl font-bold text-gray-800">
            Token Pocket Support
          </h1>
          <img src={verify} alt="verify" className="w-6 h-6 md:w-8 md:h-8" />
        </div>
        <p className="text-gray-600 mt-4 text-sm md:text-base leading-relaxed">
          We believe in delivering exceptional customer care. Our team is here
          to assist you with any questions or concerns, ensuring your experience
          is smooth and stress-free.
        </p>
        <p className="text-gray-600 mt-4 text-sm md:text-base leading-relaxed">
          Access our extensive support services, including real-time chat,
          detailed guides, and personalized assistance tailored to your needs.
        </p>
      </div>
    </div>
  );
};

export default Support;
